const DEFAULT_TARGET = '_blank'
const DEFAULT_FEATURES = 'noopener,noreferrer'
const ALLOWED_PROTOCOLS = new Set(['http:', 'https:', 'blob:'])

export interface OpenPortalExternalUrlOptions {
  target?: '_blank' | '_self'
  features?: string
}

export interface ResolvePortalBrowserUrlOptions {
  protocols?: Iterable<string>
}

export function resolvePortalBrowserUrl(url?: string | null, options: ResolvePortalBrowserUrlOptions = {}): string {
  const rawUrl = (url ?? '').trim()
  if (!rawUrl) return ''

  const normalized = new URL(rawUrl, window.location.origin)
  const protocols = new Set(options.protocols ?? ALLOWED_PROTOCOLS)
  if (!protocols.has(normalized.protocol)) return ''

  return normalized.href
}

export function resolvePortalExternalUrl(url?: string | null): string {
  return resolvePortalBrowserUrl(url, { protocols: ALLOWED_PROTOCOLS })
}

export function openPortalExternalUrl(url?: string | null, options: OpenPortalExternalUrlOptions = {}): boolean {
  const normalized = resolvePortalExternalUrl(url)
  if (!normalized) return false

  const target = options.target ?? DEFAULT_TARGET
  const features = options.features ?? DEFAULT_FEATURES
  const opened = window.open(normalized, target, features)
  if (opened && target === '_blank') {
    opened.opener = null
  }
  return Boolean(opened)
}
